import { render, staticRenderFns } from "./ReservationSelected.vue?vue&type=template&id=60f58328&"
import script from "./ReservationSelected.vue?vue&type=script&lang=js&"
export * from "./ReservationSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports